import { render, staticRenderFns } from "./TaskFinancialMetrics.vue?vue&type=template&id=ab7b456e"
import script from "./TaskFinancialMetrics.vue?vue&type=script&lang=js"
export * from "./TaskFinancialMetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports